<template>
  <section>
    <Feature :title="$t('QUOTATION_DATA_DETAIL')" :iconClass="'fa-check-square'">
      <FormRowTwo :fieldNameArr="[$t('ANNUAL_PRODUCTION_CAPACITY') + ': ', $t('ANNUAL_OUTPUT_VALUE')]"
        :fieldWidthArr="[412, 412]" :fieldSpanWidthArr="[150, 150]">
        <Input class="Input" v-model="annualProductionCapacity" slot="a" disabled>
          <span slot="append">PCS</span>
        </Input>
        <Input class="Input" v-model="annualOutputValue" slot="b" disabled>
          <span slot="append">{{ annualOutputValueCurrency }}</span>
        </Input>
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('YEAR_OF_USER'), $t('RECYCLING_YEAR')]"
        :fieldWidthArr="[412, 412]" :fieldSpanWidthArr="[150, 150]">
        <Input class="Input" v-model="yearOfUse" slot="a" disabled>
        <span slot="append">{{ $t('YEARS') }}</span>
          </Input>
        <Input class="Input" v-model="recyclingYear" slot="b" disabled>
          <span slot="append">{{ $t('YEARS') }}</span>
        </Input>
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('BENEFIT_ANALYSIS')+ ': ']"
        :fieldWidthArr="[1000]" :fieldSpanWidthArr="[150]">
        <Input v-model="benefitAnalysis" style="width: 800px" slot="a" type="textarea" disabled />
      </FormRowTwo>
      <FormRowTwo v-if="quotationView && quotationStatus === 'PROCESSING'" :fieldNameArr="[$t('SELECT_ALL')+ ': ', '']"
        :fieldWidthArr="[412]" :fieldSpanWidthArr="[150]">
        <RadioGroup v-model="selectAllType" @on-change="changeSelectAll" slot="a">
          <Radio label="Approve"></Radio>
          <Radio label="Rejected"></Radio>
        </RadioGroup>
        <Button type="primary" @click="cleanSelect" slot="b">{{ $t('CLEAR_SELECT') }}</Button>
      </FormRowTwo>
      <Table v-show="quotationView" :columns="quotationColumnList" :data="quotationList" row-key="key"></Table>
    </Feature>
    <ButtonRow>
      <Button v-if="quotationStatus === 'PROCESSING'" type="primary" @click="Submit" slot="1">{{ $t('SUBMIT') }}</Button>
      <Button type="primary" @click="Back" slot="2">{{ $t('BACK') }}</Button>
    </ButtonRow>

    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="logModel"
      :title="$t('PROCESS_LOG')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <TablePage :columnsList="quotationLogColumnList" :resultList="quotationLogList" :tableMaxHeight="800"></TablePage>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="toolingAttachmentsModel" :title="$t('SPEC_FILE')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <Table width="600" border :columns="fileSchemaList" :data="toolingAttachments">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download" @click="downloadToolingAttachment(row)"></Button>
          </template>
        </Table>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="supplierQuotationFilesModel" :title="$t('QUOTATION_FILE')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <FileDocument :attachments="supplierQuotationFiles"></FileDocument>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="commentsModel"
      :title="$t('COMMENTS')" @on-ok="confirmComments">
      <froala :config="FloraEditorConfig" v-model="comments"></froala>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="remarkModel"
      :title="$t('REMARK')" @on-ok="confirmRemark">
      <froala :config="FloraEditorConfig" v-model="remark"></froala>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="referencePriceModel" :title="$t('REFERENCE_PRICE_DATA')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <Table :columns="referencePriceColumnList" :data="referencePrices" max-height="800"></Table>
      </div>
    </Modal>
    <Modal :z-index="999" :reset-drag-position="true" width="900" v-model="cpcToSupervisorAttachmentsModel" sticky
      :draggable="true" :title="$t('REFERENCE_FILE')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <FileDocument :attachments="cpcToSupervisorAttachments"></FileDocument>
      </div>>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="1300" v-model="toolingModel"
      :title="$t('TOOLING_ATTRIBUTES')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <ToolingAttributes :toolingQuotationType="toolingQuotationType" :tooling="tooling"></ToolingAttributes>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="1300"
      v-model="flowCommentModel" :title="$t('COMMENTS')">
      <froala :config="FloraEditorConfig" v-model="flowComment"></froala>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="1300"
      v-model="logCommentModel" :title="$t('HISTORY') + ' ' + $t('COMMENTS')">
      <froala :config="FloraEditorConfig" v-model="logComment"></froala>
    </Modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import PLMDocument from '../../components/PLMDocument.vue'
import FileDocument from '../../components/FileDocument.vue'
import { Translate, FloraEditorConfig } from "@/util/common"
import { AlertInfo } from "@/util/alert"
import { FileSchemaList, ToolingMaterial } from "@/util/tableTitle"
import ToolingAttributes from "@/views/quotation/ToolingAttributes"
import FormRowTwo from '@/components/FormRowTwo'

export default {
  name: "SupervisorMaintain",
  props: {
    quotationStatus: {
      type: String
    }
  },
  components: {
    PLMDocument,
    FileDocument,
    ToolingAttributes,
    FormRowTwo
  },
  created() {
    const vueInstance = this
    if (vueInstance.getSupervisorGroupUuid()) {
      vueInstance.search()
    } else {
      vueInstance.Back()
    }
  },
  data() {
    return {
      FloraEditorConfig: FloraEditorConfig(""),
      actionType: '',
      selectAllType: '',
      quotationUuid: '',
      logModel: false,
      supplierAttachmentsModel: false,
      scalePricesModel: false,
      commentsModel: false,
      remarkModel: false,
      referencePriceModel: false,
      flowCommentModel: false,
      flowComment: '',
      quotationUuid: '',
      quotationLogList: [],
      supplierAttachments: [],
      scalePrices: [],
      comments: '',
      remark: '',
      toolingAttachments: [],
      toolingAttachmentsModel: false,
      supplierQuotationFiles: [],
      supplierQuotationFilesModel: false,
      cpcToSupervisorAttachmentsModel: false,
      cpcToSupervisorAttachments: [],
      toolingModel: false,
      abnormals: [],
      abnormalsModel: false,
      logComment: '',
      logCommentModel: false,
      tooling: {},
      toolingQuotationType: '',
      annualProductionCapacity: '',
      annualOutputValue: '',
      yearOfUse: '',
      recyclingYear: '',
      benefitAnalysis: '',
      fileSchemaList: FileSchemaList(this),
      materialColumn: ToolingMaterial(this),
      engineeringColumn: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('ENGINEERING_TL_QUANTITY');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'quantity'
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ENGINEERING_WEIGHT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'weight'
        }
      ],
      moldColumn: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('MOLD_MATERIAL');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'material'
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('MOLD_RAW_MATERIAL_PRICE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'rawMaterialPrice'
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('MOLD_PROCESSING_FEE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'processingFee'
        }
      ],
      referencePriceColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('CREATE_DATE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          key: "createDate",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('TOOLING_ID');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          key: "toolingId",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UNIT_PRICE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          key: "unitPrice",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PLANT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          key: "plant",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VENDOR');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          key: "vendor",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CAVITY');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          key: "cavity",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VALID_DATE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          key: "validationDate",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('LIFETIME');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          key: "lifeTime",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('USED_LIFETIME');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          key: "usedLifeTime",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('COMPARE_PRICE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          key: "comparePrice",
        },
      ],
      referencePrices: [],
      scalePriceColumnList: [
        {
          title: 'Item',
          key: 'item',
          align: 'center',
          width: 80
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE') + '<br>' + this.$t('QUANTITY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'scaleQuantity',
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE') + '<br>' + this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'scalePrice'
        }
      ],
      quotationLogColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('ROLE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "quotationRole",
          width: 150,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('STATUS');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "flowStatus",
          width: 150,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('GROUP_ACCOUNT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "groupAccount",
          width: 180,
          align: "center",
          render: (h, params) => {
            return h("span", {}, params.row["groupAccount"].companyName)
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ACTION');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "flowAction",
          width: 150,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('COMMENTS');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 150,
          align: "center",
          render: (h, params) => {
            if (params.row.flowComment) {
              return h("Icon", {
                props: {
                  type: "ios-paper",
                  size: 28,
                },
                class: "text-delta-blue",
                on: {
                  click: () => {
                    this.flowComment = params.row.flowComment
                    this.flowCommentModel = true
                  },
                },
              })
            } else {
              return h("span", {}, "")
            }
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CREATE_DATE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "created",
          width: 180,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PERSON_ACCOUNT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "personEmail",
          width: 200,
          align: "center",
        },
      ],
      quotationList: [],
      quotationColumnList: [
        {
          title: "#",
          align: 'center',
          width: 40,
          tree: true,
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ACTION');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 80,
          render: (h, params) => {
            let result = []
            if (params.row.resourceType == "SupervisorQuotationDetailDto") {
              if (this.quotationStatus === "CLOSE") {
                return h("div", []);
              }
              result = [
                h("Radio", {
                  style: {
                    display: "inline-block",
                    "font-size": "14px"
                  },
                  props: {
                    label: "Approve",
                  }
                }),
                h("Radio", {
                  style: {
                    display: "inline-block",
                    "font-size": "14px"
                  },
                  props: {
                    label: "Rejected",
                  }
                })
              ]
              return h('div', [
                h("RadioGroup",
                  {
                    props: {
                      value: this.quotationList[params.index].action
                    },
                    on: {
                      "on-change": (val) => {
                        this.$set(this.quotationList[params.index], 'action', val);
                      }
                    }
                  },
                  result
                ),
                h('Button', {
                  props: {
                    shape: "circle",
                    size: 'small'
                  },
                  style: { width: '80%' },
                  on: {
                    click: () => {
                      this.$set(this.quotationList[params.index], 'action', "");
                    }
                  }
                }, this.$t('CLEAR'))
              ]);
            } else if (params.row.resourceType == "AbnormalQuotationDto") {
              return h('div', [
                h('Button', {
                  props: {
                    type: params.row.status.statusViewEnum == "CANCEL" ? 'error' : 'warning',
                    shape: "circle",
                    size: 'small'
                  },
                  style: { width: '80%' },
                }, params.row.status.description)
              ]);
            }
          },
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('COMMENTS');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 90,
          render: (h, params) => {
            if (params.row.resourceType == "SupervisorQuotationDetailDto") {
              return h("Icon", {
                props: {
                  type: "ios-create",
                  size: 28,
                },
                class: "text-delta-blue",
                on: {
                  click: () => {
                    this.comments = this.quotationList[params.index].comments ? this.quotationList[params.index].comments : ""
                    this.actionType = this.quotationList[params.index].action ? this.quotationList[params.index].action : ""
                    this.quotationUuid = params.row.uuid
                    this.commentsModel = true
                  },
                },
              })
            } else {
              return h("span", {}, "")
            }
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('HISTORY') + '<br>' + this.$t('COMMENTS')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 70,
          align: 'center',
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "ios-paper",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.toggleLoading(true)
                  this.$queryQuotationLog(this, params.row.uuid).then(data => {
                    this.toggleLoading(false)
                    this.quotationUuid = params.row.uuid
                    this.logComment = ""
                    data.forEach(log => {
                      if (log.quotationRole) {
                        this.logComment = this.logComment + this.$t('ROLE') + ': ' + log.quotationRole + ', '
                      }
                      if (log.quotationRole) {
                        this.logComment = this.logComment + this.$t('STATUS') + ': ' + log.flowStatus + ', '
                      }
                      if (log.groupAccount) {
                        this.logComment = this.logComment + this.$t('GROUP_ACCOUNT') + ': ' + log.groupAccount.code + '/' + log.groupAccount.companyName + ', '
                      }
                      if (log.created) {
                        this.logComment = this.logComment + this.$t('CREATE_DATE') + ': ' + log.created + ': <br>'
                      }
                      if (log.flowComment) {
                        this.logComment = this.logComment + log.flowComment
                      }
                      this.logComment = this.logComment + '<hr style="border:1px dashed #000; height:1px">'
                    })
                    this.logCommentModel = true
                  }).catch((error) => {
                    AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
                    })
                  })
                },
              },
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RFQ_TYPE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 85,
          align: 'center',
          render: (h, params) => {
            return h("span", {}, params.row["rfqType"].description + " (" + params.row.toolingQuotationType + ")")
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('TOOLING_ID');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          key: "toolingId",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VENDOR_CODE') + "<br>" + this.$t('OA_VENDOR_NAME')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 90,
          render: (h, params) => {
            let vendorCode = params.row.vendorCode != undefined ? params.row.vendorCode : ""
            let vendorName = params.row.vendorName != undefined ? params.row.vendorName : ""
            let text = vendorCode + "<br>" + vendorName
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            let text = this.$t('TARGET') + '<br>' + this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 80,
          key: "targetPrice",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UNIT_PRICE') + "<br>" + this.$t('CURRENCY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 90,
          key: "price",
          render: (h, params) => {
            if (params.row.abnormals && params.row.abnormals.quoteRedAlert || params.row.quoteRedAlert) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'error',
                    shape: "circle",
                    size: 'small'
                  },
                  style: { width: '80%' },
                }, params.row.price),
                h("span", {}, '/' + params.row.currency)
              ]);
            } else {
              let price = params.row.price != undefined ? params.row.price : ""
              let currency = params.row.currency != undefined ? params.row.currency : ""
              let text = price + '/' + currency
              return h('div', {
                domProps: {
                  innerHTML: text
                }
              })
            }
          }
        },
        {
          renderHeader: (h, params) => {
            let text = this.$t('BASIC') + '<br' + this.$t('UNIT')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 60,
          key: "unit",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PLANT_CODE_TITLE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 50,
          key: "plant",
        },
        // {
        //   title: this.$t('SPEC_FILE'),
        //   align: 'center',
        //   width: 150,
        //   align: 'center',
        //   render: (h, params) => {
        //     return h("Icon", {
        //       props: {
        //         type: params.row.tooling && params.row.tooling.attachments ? (params.row.tooling.attachments.length > 0 ? "ios-paper" : "") : "",
        //         size: 28,
        //       },
        //       class: "text-delta-blue",
        //       on: {
        //         click: () => {
        //           this.quotationUuid = params.row.uuid
        //           this.toolingAttachments = params.row.tooling.attachments
        //           this.toolingAttachmentsModel = true
        //         },
        //       },
        //     })
        //   }
        // },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SPEC') + '<br>' + this.$t('FILES')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 60,
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "ios-paper",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.toggleLoading(true)
                  this.$readTooling(this, params.row.formNo, false).then(data => {
                    this.toggleLoading(false)
                    this.quotationUuid = params.row.uuid
                    this.toolingAttachments = data.attachments
                    this.toolingAttachmentsModel = true
                  }).catch((error) => {
                    AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
                    })
                  })
                },
              },
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('QUOTATION') + '<br>' + this.$t('FILES')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 60,
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: params.row["supplierQuotationFiles"] && params.row["supplierQuotationFiles"].filter(attachment => !attachment.deleted).length > 0 ? "ios-cloud-download" : "",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.supplierQuotationFiles = []
                  this.supplierQuotationFiles = params.row.supplierQuotationFiles.filter(attachment => !attachment.deleted)
                  this.supplierQuotationFilesModel = true
                },
              },
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('REFERENCE_FILE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 65,
          align: 'center',
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: params.row["cpcToSupervisorAttachments"] && params.row["cpcToSupervisorAttachments"].filter(attachment => !attachment.deleted).length > 0 ? "ios-cloud-download" : "",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.cpcToSupervisorAttachments = []
                  this.cpcToSupervisorAttachments = params.row.cpcToSupervisorAttachments.filter(attachment => !attachment.deleted)
                  this.cpcToSupervisorAttachmentsModel = true
                },
              },
            })
          }
        },
        // {
        //   title: this.$t('TOOLING_ATTRIBUTES'),
        //   align: 'center',
        //   width: 180,
        //   align: 'center',
        //   render: (h, params) => {
        //     if (params.row.tooling === undefined) {
        //       this.$set(this.quotationList[params.index], 'tooling', []);
        //       this.$readTooling(this, params.row.formNo, false).then(data =>{
        //         this.$set(this.quotationList[params.index], 'tooling', data);
        //       }).catch((error) => {
        //         AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
        //         })
        //       })
        //     }
        //     return h("Icon", {
        //       props: {
        //         type: params.row.tooling ? (JSON.stringify(params.row.tooling) != '{}' ? "ios-paper" : "ios-loading") : "",
        //         size: 28,
        //       },
        //       class: "text-delta-blue",
        //       on: {
        //         click: () => {
        //           if (params.row.tooling) {
        //             this.toolingQuotationType = params.row.toolingQuotationType
        //             this.quotationUuid = params.row.uuid
        //             this.tooling = params.row.tooling
        //             this.toolingModel = true
        //           }
        //         },
        //       },
        //     })
        //   }
        // },
        {
          renderHeader: (h, params) => {
            var text = this.$t('TOOLING') + '<br>' + this.$t('ATTRIBUTES')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 60,
          align: 'center',
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "ios-paper",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.toggleLoading(true)
                  this.$readTooling(this, params.row.formNo, false).then(data => {
                    this.toggleLoading(false)
                    this.toolingQuotationType = params.row.toolingQuotationType
                    this.quotationUuid = params.row.uuid
                    this.tooling = data
                    this.toolingModel = true
                  }).catch((error) => {
                    AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
                    })
                  })
                },
              },
            })
          }
        },
        // {
        //   title: this.$t('REFERENCE_PRICE_DATA'),
        //   align: 'center',
        //   width: 180,
        //   align: 'center',
        //   render: (h, params) => {
        //     return h("Icon", {
        //       props: {
        //         type: params.row.tooling && params.row.tooling.references ? (params.row.tooling.references.length > 0 ? "ios-paper" : "") : "",
        //         size: 28,
        //       },
        //       class: "text-delta-blue",
        //       on: {
        //         click: () => {
        //           this.referencePrices = params.row.tooling.references
        //           this.referencePriceModel = true
        //         },
        //       },
        //     })
        //   }
        // },
        {
          renderHeader: (h, params) => {
            var text = this.$t('REFERENCE_PRICE_DATA')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 65,
          align: 'center',
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "ios-paper",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.toggleLoading(true)
                  this.$readTooling(this, params.row.formNo, false).then(data => {
                    this.toggleLoading(false)
                    this.referencePrices = data.references
                    this.referencePriceModel = true
                  }).catch((error) => {
                    AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
                    })
                  })
                },
              },
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('REMARK')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 60,
          align: 'center',
          render: (h, params) => {
            if (params.row.resourceType == "SupervisorQuotationDetailDto") {
              return h("Icon", {
                props: {
                  type: "ios-create",
                  size: 28,
                },
                class: "text-delta-blue",
                on: {
                  click: () => {
                    this.remark = this.quotationList[params.index].remark
                    this.quotationUuid = params.row.id
                    this.remarkModel = true
                  },
                },
              })
            } else {
              return h("span", {}, "")
            }
          }
        },
        // {
        //   title: this.$t('LOG'),
        //   width: 120,
        //   align: 'center',
        //   render: (h, params) => {
        //     if (params.row.resourceType == "SupervisorQuotationDetailDto" && params.row.quotationLogList === undefined) {
        //       this.$set(this.quotationList[params.index], 'quotationLogList', []);
        //       this.$queryQuotationLog(this, params.row.uuid).then(data => {
        //         this.$set(this.quotationList[params.index], 'quotationLogList', data);
        //       }).catch((error) => {
        //         AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
        //         })
        //       })
        //     }
        //     return h("Icon", {
        //       props: {
        //         type: params.row.quotationLogList ? (params.row.quotationLogList.length > 0 ? "ios-paper" : "ios-loading") : "",
        //         size: 28,
        //       },
        //       class: "text-delta-blue",
        //       on: {
        //         click: () => {
        //           if (params.row.quotationLogList && params.row.quotationLogList.length > 0) {
        //             this.quotationUuid = params.row.uuid
        //             this.quotationLogList = params.row.quotationLogList
        //             this.logModel = true
        //           }
        //         },
        //       },
        //     })
        //   }
        // },
        {
          renderHeader: (h, params) => {
            var text = this.$t('LOG')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 60,
          align: 'center',
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "ios-paper",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.toggleLoading(true)
                  this.$queryQuotationLog(this, params.row.uuid).then(data => {
                    this.toggleLoading(false)
                    this.quotationUuid = params.row.uuid
                    this.quotationLogList = data
                    this.logModel = true
                  }).catch((error) => {
                    AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
                    })
                  })
                },
              },
            })
          }
        },
      ]
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getSupervisorGroupUuid", "getSupervisorGroupId", "getModalSize"]),
    ...mapActions(["toggleLoading"]),
    changeSelectAll() {
      this.quotationList.forEach(quotation => {
        let index = this.quotationList.findIndex(temp => temp.uuid == quotation.uuid)
        this.$set(this.quotationList[index], 'action', this.selectAllType);
      })
    },
    cleanSelect() {
      this.selectAllType = ""
      this.quotationList.forEach(quotation => {
        let index = this.quotationList.findIndex(temp => temp.uuid == quotation.uuid)
        this.$set(this.quotationList[index], 'action', undefined);
      })
    },
    search() {
      const vueInstance = this
      vueInstance.selectAllType = ""
      vueInstance.toggleLoading(true)
      vueInstance.$quotationHttp
        .get("/supervisor/details/group/" + vueInstance.getSupervisorGroupUuid())
        .then((response) => {
          vueInstance.toggleLoading(false)
          if (response.data && response.data._embedded) {
            vueInstance.quotationList = response.data._embedded.supervisorQuotationDetailResourceList
            let tempQuotation = vueInstance.quotationList[0]
            vueInstance.annualProductionCapacity = tempQuotation.annualProductionCapacity
            vueInstance.annualOutputValue = tempQuotation.annualOutputValue
            vueInstance.yearOfUse = tempQuotation.yearOfUse
            vueInstance.recyclingYear = tempQuotation.recyclingYear
            vueInstance.benefitAnalysis = tempQuotation.benefitAnalysis
            vueInstance.quotationList.forEach(quotation => {
              vueInstance.$queryAbnormals(vueInstance, quotation.uuid).then(data => {
                if (data) {
                  data.forEach(abnormalQuotation => {
                    abnormalQuotation.key = quotation.uuid + "_" + abnormalQuotation.uuid
                    abnormalQuotation.tooling = abnormalQuotation.toolingQuotationDto
                  })
                  quotation.key = quotation.uuid
                  quotation.children = data
                  quotation._showChildren = true
                  let index = vueInstance.quotationList.findIndex((temp) => temp.uuid == quotation.uuid)
                  vueInstance.$set(vueInstance.quotationList, index, quotation)
                }
              })
            })
          }
        })
        .catch(() => {
          vueInstance.toggleLoading(false)
        })
    },
    Submit() {
      const vueInstance = this
      if (vueInstance.quotationList.some(quotation => quotation.action === undefined || quotation.action === "") === true) {
        AlertInfo(vueInstance, vueInstance.$t('CHOOSE'))
          .then(() => {});
        return;
      }
      vueInstance.toggleLoading(true);
      let quotationRequestListForApprove = [];
      let quotationRequestListForReject = [];
      vueInstance.quotationList.forEach(quotation => {
        switch (quotation.action) {
          case "Approve":
            quotationRequestListForApprove.push({
              uuid: quotation.uuid,
              comments: quotation.comments
            });
            break;
          case "Rejected":
            quotationRequestListForReject.push({
              uuid: quotation.uuid,
              comments: quotation.comments
            });
            break;
        }
      });
      vueInstance.$quotationHttp
        .post("/supervisor/tooling/submit", {
          groupId: vueInstance.quotationList[0].groupId,
          quotationRequestListForApprove: quotationRequestListForApprove,
          quotationRequestListForReject: quotationRequestListForReject
        })
        .then(response => {
          vueInstance.$Swal.fire({
            icon: "info",
            title: vueInstance.$t("COMMON_MESSAGE_INFO"),
            html: "Group: " + response.data.content[0].id + ", " + response.data.content[0].status,
          });
          vueInstance.$router.push({
            name: "SUPERVISOR_MAINTAIN"
          });
        })
        .catch(error => {
          if (error.response.status == 444) {
            let text = vueInstance.$buildErrorMessage(error)
            vueInstance.$Swal.fire({
              icon: "error",
              title: Translate("COMMON_MESSAGE_ERROR"),
              text,
            });
          }
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    confirmComments() {
      const vueInstance = this
      vueInstance.quotationList.forEach(temp => {
        if (temp.id == vueInstance.quotationUuid) {
          temp.comments = vueInstance.comments
        } else if (vueInstance.actionType && vueInstance.actionType == temp.action) {
          temp.comments = vueInstance.comments
        }
      })
    },
    confirmRemark() {
      this.quotationList.forEach(temp => {
        if (temp.id == this.quotationUuid) {
          temp.remark = this.remark
        }
      })
    },
    downloadToolingAttachment(row) {
      this.$downloadToolingAttachment(this, this.quotationUuid, row.uuid)
    },
    Back() {
      this.$router.push({ name: 'SUPERVISOR_MAINTAIN' })
    }
  },
  computed: {
    quotationView() {
      return this.quotationList && this.quotationList.length > 0
    },
    modalSize() {
      return this.getModalSize()
    },
    annualOutputValueCurrency() {
      let result = "USD"
      if (!this.quotationList[0]) {
      } else if (this.quotationList[0].toolingId.includes("CN")) {
        result = "RMB"
      } else if (this.quotationList[0].toolingId.includes("TW")) {
        result = "TWD"
      } else if (this.quotationList[0].toolingId.includes("TH")) {
        result = "RMB"
      } else if (this.quotationList[0].toolingId.includes("IN")) {
        result = "INR"
      }
      return result
    }
  }
}
</script>

<style scoped></style>
